
import { Module } from '../../types';
import { HOOKS_DEEP_DIVE_CONTENT } from './content';
import { HOOKS_DEEP_DIVE_CODE_EXAMPLES } from './examples';
import { HOOKS_DEEP_DIVE_PRACTICE } from './practice';
import { HOOKS_DEEP_DIVE_QUIZ } from './quiz';

export const HOOKS_DEEP_DIVE_MODULE: Module = {
  id: "intermediate-hooks",
  title: "React Hooks Deep Dive",
  description: "Master advanced React hooks patterns and create custom hooks for complex scenarios",
  duration: "2 hours",
  difficulty: "intermediate",
  content: HOOKS_DEEP_DIVE_CONTENT,
  codeExamples: HOOKS_DEEP_DIVE_CODE_EXAMPLES,
  practice: HOOKS_DEEP_DIVE_PRACTICE,
  quickCheck: HOOKS_DEEP_DIVE_QUIZ
};
